//
//
//
//
//
//
//
//

import { EVENTS } from '@/scripts/constants/css-classes'
export default {
  name: 'rb-anchor',
  inject: ['color', 'scrollToElement'],
  props: {
    id: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentScroll: 0,
    }
  },
  computed: {
    modifierClasses() {
      return {
        [`rb-anchor__container--${this.color}`]: this.color,
        ['rb-anchor__container--is-active']: this.isActive,
      }
    },
    pathName() {
      return `${window.location.pathname}#`
    },
    targetId() {
      return this.href.split(this.pathName)[1]
    },
    targetElement() {
      return document.getElementById(this.targetId)
    },
    currentCoordinates() {
      return this.$refs.anchor.getBoundingClientRect()
    },
    isActive() {
      const currentScroll = this.currentScroll
      const targetElement = document.getElementById(this.targetId)
      if (!targetElement) {
        return false
      }

      const parentHeight = 72

      const offsetTop = targetElement.offsetTop
      const offsetHeight = targetElement.offsetHeight

      const isActive =
        currentScroll < offsetTop + offsetHeight - parentHeight && currentScroll > offsetTop
      return isActive
    },
  },
  watch: {
    isActive(next, prev) {
      if (prev != next && next) {
        this.scrollToElement(this)
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateCurrentScroll()
      document.addEventListener(EVENTS.SCROLL, this.updateCurrentScroll)
    })
  },
  beforeDestroy() {
    document.removeEventListener(EVENTS.SCROLL, this.updateCurrentScroll)
  },
  methods: {
    updateCurrentScroll() {
      this.currentScroll = window.scrollY
    },
    onClick() {
      if (this.href) {
        if (this.href.includes(this.pathName)) {
          const targetElement = this.targetElement
          const parentBar = this.$parent.$el
          if (targetElement && parentBar) {
            const targetY =
              targetElement.getBoundingClientRect().top + window.scrollY - parentBar.offsetHeight
            window.scrollTo({ top: targetY, behavior: 'smooth' })
          }
        } else {
          window.location.href = this.href
        }
      } else {
        this.$emit('click')
      }
    },
  },
}
